import { render, staticRenderFns } from "./FamilyReferences.vue?vue&type=template&id=41bd55df&"
import script from "./FamilyReferences.vue?vue&type=script&lang=js&"
export * from "./FamilyReferences.vue?vue&type=script&lang=js&"
import style0 from "./FamilyReferences.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('41bd55df')) {
      api.createRecord('41bd55df', component.options)
    } else {
      api.reload('41bd55df', component.options)
    }
    module.hot.accept("./FamilyReferences.vue?vue&type=template&id=41bd55df&", function () {
      api.rerender('41bd55df', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/candidates/family-references/FamilyReferences.vue"
export default component.exports